module.exports = __webpack_public_path__ + "static/media/22.cbdc2212.wav";